// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

type StyleParams = {
  variant: 'other' | 'current';
};

export default createStyles((theme, { variant }: StyleParams) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.other.spacing._8,
    width: '100%',
    flexDirection: 'row',
    justifyContent: variant === 'current' ? 'flex-end' : 'flex-start',
  },

  avatar: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  bubble: {
    backgroundColor: variant === 'current' ? theme.colors.gray2[5] : theme.colors.gray2[0],
    borderRadius: theme.other.spacing._8,
    padding: `${theme.other.spacing._12}px ${theme.other.spacing._16}px ${theme.other.spacing._8}px ${theme.other.spacing._16}px`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._4,
    maxWidth: variant === 'current' ? 'calc(100% - 16px)' : 'calc(100% - 32px)', // No avatar space needed for current user
    minWidth: variant === 'other' ? 218 : 150,
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 20,
    width: '100%',
  },

  handleSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.other.spacing._4,
    flex: 1,
    minWidth: 0,
  },

  handle: {
    color: variant === 'current' ? theme.white : theme.colors.gray2[6],
    fontSize: 14,
    fontWeight: 900,
    lineHeight: '20px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },

  commissionerBadge: {
    width: 12,
    height: 12,
    flexShrink: 0,
  },

  message: {
    wordBreak: 'break-word',
  },

  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 20,
    width: '100%',
  },

  reactions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
  },

  emojiContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.other.spacing._2,
  },

  emoji: {
    fontSize: 16,
    lineHeight: '22px',
    color: theme.colors.gray2[3],
  },

  reactionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 20,
    height: 20,
    border: 'none',
    borderRadius: 0,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    padding: 0,
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.7,
    },
    '&:active': {
      opacity: 0.5,
    },
    '&:focus': {
      outline: 'none', // Remove focus outline
    },
  },

  reactionImage: {
    width: 16,
    height: 16,
    objectFit: 'contain',
  },

  reactionCount: {
    color: variant === 'current' ? theme.white : theme.colors.gray2[5],
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
  },

  timestamp: {
    color: variant === 'current' ? theme.colors.gray2[3] : theme.colors.gray2[4],
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    whiteSpace: 'nowrap',
  },

  optionsButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 24,
    cursor: 'pointer',
    borderRadius: theme.other.spacing._4,
    padding: 0,
    border: 'none',
    marginRight: -theme.other.spacing._4,
    background: 'transparent',
    '&:hover': {
      backgroundColor: variant === 'current' ? theme.colors.gray2[4] : theme.colors.gray2[1],
    },
  },
}));
